import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReporteData } from 'src/app/models';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppState } from 'src/app/state/app.state';
import { Store } from '@ngrx/store';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-acta-busqueda',
  templateUrl: './acta-busqueda.component.html',
  styleUrls: ['./acta-busqueda.component.scss']
})
export class ActaBusquedaComponent implements OnInit {
  @Input() turnosActivos: any;
  @Input() jefesTurno:any;
  @Input() cobradores:any;
  loadingIndicator:boolean = false;
  public formBusqueda:FormGroup; //formulario de busqueda
  carriles:any[] = [];
  caseta:number;
  turnosNames = {
    1: 'NOCTURNO',
    2: 'MATUTINO',
    3: 'VESPERTINO'
  }

  //DATA TABLE
  rows: ReporteData = null;
  colums = [ { name: 'FECHA CREACIÓN'}, { name: 'FECHA SUCESO' }, { name: 'TURNO' }, { name: 'CARRIL' },  { name: 'COBRADOR' } , { name: 'JEFE DE TURNO' }, {name: 'DESCARGA'}];
  ColumnMode = ColumnMode;
  constructor(private formBuilder:FormBuilder,
              private reporteService:ReporteriaService,
              private ngxUiLoaderService:NgxUiLoaderService,
              private store: Store<AppState>,
              private toastr:ToastrService, ) { }

  ngOnInit(): void {
    this.createForm();
    this.getData();
  }

  createForm() {
    this.formBusqueda = this.formBuilder.group({
      tipoActa: ['', Validators.required], //tipo acta obligatoria
      fecha: [''],
      turno: [''],
      cobrador : [''],
      carriles : [''],
      jefeTurno: [''],
    });
  }

  async getData() {
    this.ngxUiLoaderService.start('1');
    this.caseta = this.getCasetaUser().id;
    this.carriles = await this.getCarrilesByCaseta(this.caseta);
    this.ngxUiLoaderService.stop('1');
  }

  getCasetaUser() {
    let casetaTroncal;
    this.store.select(selectUser).subscribe( usuario => { // Obtener info del usuario
      casetaTroncal = usuario.caseta_usuario.find(caseta => caseta.tipo === 1);// Obtener caseta troncal
    });
    return casetaTroncal;
  }

  getCarrilesByCaseta(id_caseta:number) {
    return this.reporteService.getCarriles(id_caseta);
  }

  // consumir api
  searchData() {
    this.loadingIndicator = true;
    this.reporteService.getDataActaPDF(1, this.formBusqueda.value)//numero pagina , formData
    .then(infoActas => {
         console.log(infoActas);
         this.loadingIndicator = false;
         this.rows = infoActas;
         console.log(this.rows.data);
    })
    .catch(error => {
      this.loadingIndicator = false;
    });
  }

  setPage(event){
   this.loadingIndicator = true;
   let page = event.offset + 1;
   this.reporteService.getDataActaPDF(page, this.formBusqueda.value)
   .then(actas => {
      this.rows = actas;
      this.loadingIndicator = false;
    });
  }

  async downloadActa(filename:string){
    this.ngxUiLoaderService.start('download');
    let file:Blob = await this.reporteService.downloadFile(filename);
    let urlDownload = this.reporteService.downloadExcel(file, filename);
    if(urlDownload != ''){
      this.ngxUiLoaderService.stop('download');
      return this.toastr.success('Se ha descargado con éxito el acta', '', { positionClass: 'toast-bottom-right' })  
    }
  }
}
